export const NUMBER_PAGE_FILTER = [
  {
    label: "10件",
    key: "10",
  },
  {
    label: "25件",
    key: "25",
  },
  {
    label: "50件",
    key: "50",
  },
  {
    label: "100件",
    key: "100",
  },
  {
    label: "全件",
    key: "all",
  },
];

export const DROPDOWN_ROLE = [
  { key: "0", label: "すべて", color: "" },
  { key: "1", label: "管理者", color: "green" },
  { key: "2", label: "SWX管理ユーザ", color: "geekblue" },
  { key: "3", label: "保証会社ユーザ", color: "purple" },
  { key: "4", label: "金融機関ユーザ", color: "magenta" },
  { key: "5", label: "エンドユーザ", color: "gold" },
];

export const DROPDOWN_STATUS = [
  { key: "-1", label: "すべて" },
  { key: "0", label: "新規作成" },
  { key: "1", label: "SMS認証待ち" },
  { key: "2", label: "SMS認証済み" },
  { key: "3", label: "Webゆうびん送信済み" },
  { key: "4", label: "有効" },
  { key: "5", label: "解約依頼" },
  { key: "99", label: "無効" },
];

export const USER_STATUS = [
  { key: "ユーザ登録完了", label: "新規作成", color: "orange" },
  { key: "メール認証完了", label: "SMS認証待ち", color: "cyan" },
  { key: "SMS認証完了", label: "SMS認証済み", color: "processing" },
  { key: "Web郵便送信済", label: "Webゆうびん送信済み", color: "purple" },
  { key: "有効", label: "有効", color: "success" },
  { key: "無効", label: "無効", color: "red" },
  { key: "解約依頼", label: "解約依頼", color: "yellow" },
];
export const FINANCE_TYPE = [
  { key: "all", label: "すべて" },
  { key: "0", label: "標準融資" },
  { key: "1", label: "信用保証協会" },
  { key: "2", label: "POファイナンス" },
  { key: "10", label: 'ネクサローン' }, // 商工中金専用
  { key: "99", label: "その他" },
];
export const STATUS = [
  { key: "all", label: "すべて" },
  { key: "0", label: "依頼受付" },
  { key: "1", label: "確認中" },
  { key: "2", label: "追加依頼中" },
  { key: "3", label: "審査中" },
  { key: "4", label: "審査謝絕" },
  { key: "5", label: "審査許諾" },
  { key: "99", label: "融資申込取消" },
];
export const FINANCE_AGENCY_STATUS = [
  { key: "all", label: "すべて" },
  { key: "0", label: "新規作成" },
  { key: "1", label: "協会受付待ち" },
  { key: "2", label: "協会審査中" },
  { key: "3", label: "保証書発行" },
  { key: "4", label: "保証取消" },
  { key: "5", label: "削除予定" },
];

export const TRADE_ORDER_STATUS = {
  NEW_LOAN_REQUEST: 0, // 依頼受付
  LOAN_REQUEST_RECEIVED: 1, // 確認中
  CORRECTION_REQUEST_IN_PROGRESS: 2, // 追加依頼中
  UNDER_REVIEW: 3, // 審査中
  REJECT: 4, // 審査謝絕
  APPROVED: 5, // 審査許諾
  CANCEL: 99, // 融資申込取消
};

export const CORP_TYPE = [
  { key: 0, value: "法人" },
  { key: 1, value: "個人" },
];

export const ACTIVATION_STATUS = [
  { key: "0", label: "すべて" },
  { key: "1", label: "SMS認証待ち", color: "cyan" },
  { key: "2", label: "SMS認証済み", color: "processing" },
  { key: "3", label: "Webゆうびん送信済み", color: "purple" },
  { key: "4", label: "有効", color: "success" },
  { key: "5", label: "解約依頼", color: "yellow" },
  { key: "99", label: "無効", color: "red" },
];

export const ADMIN_ROLE = {
  ADMIN: 1, // 管理者
  SWX_ADMIN: 2, // SWX管理ユーザ
  GUARANTEE_ADMIN: 3, // 保証会社ユーザ
  FINANCIAL_INSTITUTION_ADMIN: 4, // 金融機関ユーザ
};

export const ADMIN_ROLE_NAME = {
  1: "管理者",
  2: "SWX管理ユーザ",
  3: "保証会社ユーザ",
  4: "金融機関ユーザ",
};

export const END_USER_ROLE = {
  END_USER: 5, // エンドユーザ
};

export const MIN_FILE_SIZE = 0;
export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const ALLOWED_TYPE_FILE = [
  "jpg",
  "png",
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "zip",
  "csv",
];

export const COLOURS = {
  new: "blue",
  used: "#36cfc9",
  accepted: "green",
  rejected: "red",
  failed: "#00000040",
  neverchange: "#faad14",
};

export const DATE_FORMAT = "YYYY/MM/DD";
export const TIME_OUT = 5000; // mili-seconds

export const REGEX = {
  email: /^(?=.{1,64}$)[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/,
  phone_number: /^(\d{2,4}-\d{2,4}-\d{4})$|^\d{10,11}$/,
}

export const YOKIN_TYPE = [
  { key: 1, value: "普通" },
  { key: 2, value: "当座" },
];

export const GENDER = [
  { key: 0, value: "男" },
  { key: 1, value: "女" },
];

export const UPDATE_STATUS_LOAN = [
  { key: "1", label: "確認中(ロック) " },
  { key: "2", label: "追加依頼中(編集可)" },
];

export const STATUS_LOAN_UPDATE_FOR_FINANCE = {
  LOAN_REQUEST_RECEIVED: 1, // 確認中
  CORRECTION_REQUEST_IN_PROGRESS: 2, // 追加依頼中
  UNDER_REVIEW: 3, // 審査中
}

export const USER_STATUSES = {
  FINISH_REGISTERING_USER: 0, //ユーザ登録完了
  FINISH_VERIFYING_EMAIL: 1,  // メール認証完了
  FINISH_VERIFYING_SMS: 2,  // SMS認証完了
  WEB_YUBIN_SENT: 3,  // Web郵便送信済
  ACTIVE: 4, // 有効（Web郵便認証完了）
  INACTIVE: 99, // 無効
  CANCELLATION_REQUEST: 5, // 解約依頼
}

export const BANK_ACCOUNT_VALUE = {
  WITHOUT_ACCOUNT: 0, // なし
  WITH_ACCOUNT: 1, // あり
}

export const BANK_ACCOUNT = [
  { key: 0, value: "なし" },
  { key: 1, value: "あり" },
]